export const UI_SELECT: string = "ui_select";

export const UI_CLICK: string = "ui_click";
export const ONBOARDING_SHOW: string = "onboarding-show";

export const CHEER_START = "crowd-cheer-start";
export const CHEER_LOOP = "crowd-cheer";
export const BUTTON_APPEAR = "ding-ding";
export const BALLOON_SPAWN = "balloon-release";
export const CONFETTI_SPAWN = "chime-basic";
export const BALLOON_POP_1 = "pop-1";
export const BALLOON_POP_2 = "pop-2";
export const DANCE_UNLOCKED = "dance-icon-change";
export const GLOBE_CLICKED = "fuujin-air-gust";
export const CAMERA_BUTTON_APPEAR = "camera-button-appears";
export const CAMERA_CLICKED = "camera";
export const PHOTO_APPEAR = "chime-balloon-reveal";

export const IMPACT_1 = "impact-tree";
export const IMPACT_2 = "impact-boing-light";
export const IMPACT_3 = "impact-boomarang";
export const IMPACT_4 = "impact-colourbomb";
export const IMPACT_5 = "impact-metal";
export const IMPACT_6 = "impact-paper-lantern";
export const IMPACT_7 = "impact-satellite";
export const IMPACT_8 = "impact-stick";
export const IMPACTS = [IMPACT_1, IMPACT_2, IMPACT_3, IMPACT_4, IMPACT_5, IMPACT_6, IMPACT_7, IMPACT_8];
